import { AguaBuscaCuentas, AuxJasper, BuscaCobros, CargosDetalles, Cobros, EnviarCorreo, FacturacionData,  ParametroJasper, PersonaClientes, Personas, WizpokIntentoPagoRequest } from './../../entidades/entidades';
import { PersonasService } from './../../servicios/personas.service';

import { CargosDetallesOnlineComponent } from './../cargos-detalles-online/cargos-detalles-online.component';

import { AuthenticationService } from 'app/servicios';
import { PrivilegiosService } from './../../servicios/privilegios.service';
// prettier-ignore
import { Component, OnInit, EventEmitter, ViewChild, Output } from "@angular/core";
import { Aguas, CargosDetallesInput, EstadoCuentaInformacionInput, PayCard} from "app/entidades/entidades";
import { MuestraMensaje } from "app/shared/utilerias/notificaciones/notificaciones.component";
import { EstadoCuentaInformacionOnlineComponent } from "../estado-cuenta-informacion-online/estado-cuenta-informacion-online.component";
import { first } from 'rxjs/operators';

import { Message, MessageService, SelectItem } from 'primeng/api';
import { PayCardService } from 'app/servicios/pay-card.service';
import { CatCfdiUsosService } from 'app/servicios/cat-cfdi-usos.service';
import { FormGroup,FormBuilder,Validators, AbstractControl } from '@angular/forms';
import { DatosCfdiFacturasService } from 'app/servicios/datos-cfdi-facturas.service';
import { CatMedioPagosService } from '../../servicios/cat-medio-pagos.service';
import { ActivatedRoute } from '@angular/router';
import { AguaBuscaCuentaOnlineComponent } from '../agua-busca-cuenta-online/agua-busca-cuenta-online.component';
import { BuscaCobrosService } from 'app/servicios/busca-cobros.service';
import { CatRegimenFiscalService } from 'app/servicios/cat-regimen-fiscal.service';

interface item {
  name: string;
  code: string;
}
@Component({
  selector: 'app-estado-cuenta-online',
  templateUrl: './estado-cuenta-online.component.html',
  styleUrls: ['./estado-cuenta-online.component.css']
})
export class EstadoCuentaOnlineComponent implements OnInit {
  bandera: boolean = false;
  idAguasProceso: number;
  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();

  
  public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();


  muestraMensaje = new MuestraMensaje();
  public cargosDetallesInputLimpio: CargosDetallesInput;
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  mensajeForm: FormGroup;
  public displayMaximizable: boolean;
  public displayFacturaOgenerico:boolean;

  public flagAceptoLosTerminos:boolean;
  msgs: Message[];
  _totalAdeudo=0;

  // _nombre:string;
  // _razonSocial:string;
  // _rfc:string;
  // _email:string;
  facturaForm = this.formBuilder.group({
    nombre: ['', this.validaNombreORazonSocial()],
    razonSocial: ['', this.validaNombreORazonSocial()],
    correoElectronico: ['', [Validators.required, Validators.email]],
    rfc: ['', Validators.required],
    // usoCFDI: ['' ,], 
    cp: ['', Validators.required],
    selectedCFDI: ['', Validators.required],
    selectedRegimenFiscal: ['', Validators.required],
  });
  
  _flagDatosFactura:boolean;
  
  _esfactura:boolean= true;
  _muestraBtnPago:boolean = true;

  display: boolean = false;

  lstCfdi: SelectItem[] = [];
  lstRegimenFiscal: SelectItem[] = [];

  // selectedCFDI: item;
  public enviaCorreo = new EnviarCorreo();
  displayBasic: boolean;
  esRazonSocial:boolean;
  _id_factura: number;
  _tipoRecibo:number;
  enviaC: boolean = false;
  public progressBar = false;
  public errorTimbre : boolean = false; 
  public flagReintento:boolean=false;
  public urlToPay:string;
  public cuentaAguaParam:string;
  public referenciaPayment:string;
  public flagRedirect:boolean=false;
  public txtResponse:string;
  public flagAprobada:boolean=false;
  public referencia:string;
  public msjProgresBar:string="PROCESANDO ... ";
  public flagFacturaGenerica:boolean=false;
  private _adeudoSinRedondeo: number;
 

  handleChange(e) {
    this.enviaC = e.checked;
  }


  
  public auxJasper: AuxJasper;
  public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
  @ViewChild(EstadoCuentaInformacionOnlineComponent, { static: false }) childEstadoCuentaInformacion;
  @ViewChild(CargosDetallesOnlineComponent, { static: false }) childCargosDetalles;
  @ViewChild(AguaBuscaCuentaOnlineComponent,{ static: false }) childAguaBuscaCuentaAux;

  constructor(private privilegiosService: PrivilegiosService,
    private authenticationService:AuthenticationService,
    private payCardService: PayCardService,
    private messageService: MessageService,
    private catCfdiUsosService: CatCfdiUsosService,
    private catRegimenFiscalService: CatRegimenFiscalService,
    private  personaService: PersonasService,
    private formBuilder: FormBuilder,
    private datosCfdiFacturasService: DatosCfdiFacturasService,
    private route: ActivatedRoute,
    private buscaCobrosService:BuscaCobrosService,
    

    ) {
   
    


   }
  // showBasicDialog() {
  //   this.limpiaPagoEnLinea();
  //      this.bandera = true;
  // }
 async  ngOnInit() { 
   this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });
   this.messageService.add({ severity: 'success', summary: 'Service Message', detail: 'Via MessageService' });

    //recibe parametro, si es pago express
    this.route.paramMap.subscribe(params => {
        this.cuentaAguaParam = params.get('cuentaagua')!;
     });
     //recibimos parametros, de redireccionamiento, de pago.
      this.route.queryParams.subscribe(async params => {

      this.flagRedirect = params['success'];
      // const nuAut = params['nuAut'];
      // const operacion = params['operacion'];
      // const fecha = params['fecha'];
      // const banco = params['banco'];
      // const marca = params['marca'];
      // const tpTdc = params['tpTdc'];
      // const nbMerchant = params['nb_merchant'];
      this.flagAprobada = params['nbResponse']=="Aprobado"?true:false;
      // const sucursal = params['sucursal'];
      // const empresa = params['empresa'];
      // const importe = params['importe'];
      this.referencia= params['referencia'];
      this.referenciaPayment= params['referenciaPayment'];
      // const nbMoneda = params['nbMoneda'];
      // const cdEmpresa = params['cdEmpresa'];
      // const urlTokenId = params['urlTokenId'];
      // const idLiga = params['idLiga'];
        
      this.facturaForm.patchValue({
        email:  params['email']
      });

      this.txtResponse = params['cdResponse'];
 
    });
    
    this.displayFacturaOgenerico=false;
    this._flagDatosFactura=false;
    // if(this.cuentaAguaParam || this.flagRedirect) //omito, la parte de los terminos, en el pago express redirect y tambien se omite en el pago en linea.
    // {  
      this.displayMaximizable = false;
      this.flagAceptoLosTerminos=true;
      await  this.aceptoLosTerminos();
  //  }
  //  else{
  //     this.displayMaximizable = true;
  //     this.flagAceptoLosTerminos=false;
  //   }
 

 }
  async ngAfterGetToken() {

    if(this.cuentaAguaParam) //solo aplica si es pago express
    { 
      try {
       this.childAguaBuscaCuentaAux.ngOnInit();
       this.childAguaBuscaCuentaAux.datosCuentaAguaForm.patchValue({cuentaAgua:this.cuentaAguaParam});
       await    this.childAguaBuscaCuentaAux.buscaCuentaAgua();
      } catch (error) {
        console.log("Error en ngAfterViewInit en pago express",error);  
        this.muestraMensaje.error("Error al cargar la información ", "top", "center"); 
      }
    }else if(this.flagRedirect ) // redirect de pago en linea.
    {
      //valida si el pago, se aprobo o no.
      if(this.flagAprobada)
      {
        try{
           this.msjProgresBar= ' Por favor espere...';          //espera 20 segundos, en lo que se refleja el pago por medio del api .
           this.showBar();  
           await this.delay(20000);
           this._id_factura= await this.getIdCobroByCuentaAgua(this.referencia);// se obtiene el id pago 
           this.displayFacturaOgenerico=true;
            //precarga información del la persona.
           
            let persona= await this.personaService.getPersonaByReferencia(this.referencia).toPromise();
            if (persona)
            {
               this.facturaForm.patchValue({
                 nombre: persona.PrimerApellido  + " " + persona.SegundoApellido + " " + persona.Nombre,  
                 razonSocial: persona.RazonSocial,
                 rfc: persona.Rfc,
                 codigoPostal: persona.Cp
               });
             
              this.facturaForm.get('selectedRegimenFiscal').valueChanges.subscribe(async (idRegimen) => {
              
                this.lstCfdi=[];
                this.facturaForm.patchValue({
                  selectedCFDI: null
                });
                await this.getCfdiUsoByRegimenFiscal(idRegimen);
               });

              if (persona.IdTipoPersona==2)
                     this.esRazonSocial=true;
            }



        } catch (error) {
           console.log("Error en ngAfterViewInit en redirecto de pago en linea",error);  
            this.muestraMensaje.error("Error al cargar la información ", "top", "center"); 
        }finally{
          this.progressBar=false;
        }
      }
      else
          this.muestraMensaje.errorTimer(this.txtResponse , "top", "center", 15000);
    }

  }

  onDialogHide() {
    this.displayFacturaOgenerico=true;
 }
  validaNombreORazonSocial() {
    return () => {
      const nombre = this.facturaForm?.get('nombre');
      const razonSocial = this.facturaForm?.get('razonSocial');
      if ((!nombre || !nombre.value) && (!razonSocial || !razonSocial.value)) {
        return { requiredIf: true };
      }
  
      return null;
    };
  }
   delay(milliseconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }
  async childAguaBuscaCuentas(agua: Aguas) {

    if (!agua) 
        return;
  
    let idAgua=agua.id;
    try {
       this.idAguasProceso = idAgua;

      if (!this.idAguasProceso) {
        this.cargosDetallesInput$.emit(null);
        this.estadoCuentaInformacionInput$.emit(null);
        return;
      }

      //Carga detalle adeudos
      let cargosDetallesInput = new CargosDetallesInput();
      cargosDetallesInput.idAgua = idAgua;
      cargosDetallesInput.idEstatus = 1;
      await this.cargosDetallesInput$.emit(cargosDetallesInput);

      //Carga Informacion Estado de Cuenta
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = idAgua;
      // estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
   
      await this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);
      if(this._totalAdeudo>0)
        this._muestraBtnPago=true;
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
    }
  }

  async totalAdeudoOutput(totalAdeudo: number) {
    debugger;
     if(this.childEstadoCuentaInformacion)
       {
      
         //limpiar las variables
          this.limpiaPagoEnLinea();
          if(this.childEstadoCuentaInformacion.estadoCuentaTable){
          this.childEstadoCuentaInformacion.estadoCuentaTable[0].total = totalAdeudo;
          }
          this._adeudoSinRedondeo=totalAdeudo;
          this._totalAdeudo =  totalAdeudo ;

        }

      
        if(this.cuentaAguaParam &&  this._totalAdeudo>0)// valida si recibe el parametro, de una cuenta de agua, pago express y si tiene adeudo.
            this.realizaPago();
        
  }
  limpiaPagoEnLinea(){
    this.bandera=false;
    this.facturaForm.reset();

  }
  async requiereCFDI(){
      this.flagFacturaGenerica=false;
      this.displayFacturaOgenerico=false;
      this._flagDatosFactura=true;
      this.bandera=false;
      let catRegimenFiscal =  await this.catRegimenFiscalService.getAll().toPromise();
      catRegimenFiscal.filter(x=>this.asignaTolstRegimen(x));
  }
  async getCfdiUsoByRegimenFiscal(idRegimenFiscal:number)
  {
      if(idRegimenFiscal)
      {
        let catCfdiUso =  await this.catCfdiUsosService.getByRegimen(idRegimenFiscal).toPromise();
        catCfdiUso.filter(x=>this.asignaTolstCfdi(x));  
      }
  }   
  async realizaFactura(){
    
    let error: string = "";
    if (this.facturaForm.invalid) 
    {
      error += "*.- Los campos marcados son requeridos \n";
      return;
    } 
        if (!this.facturaForm.value.selectedCFDI)
          error += "*.- selecciona el uso del CFDI \n";

          if (error.length > 0) {
           this.msgs = [{ severity: 'error', summary: 'Error', detail: error }];
           return;
         }

         this.msjProgresBar= 'Realizando Factura, por favor espere...'
         this.showBar();  
         this._flagDatosFactura=false;

        let  facturacionData = new FacturacionData();
           facturacionData.id=this._id_factura;// se asigna el id pago.
           facturacionData.usoCFDI=(await this.catCfdiUsosService.getSingle( Number(this.facturaForm.value.selectedCFDI)).toPromise());
  
        let objPersona = new PersonaClientes();
           objPersona.nombre=this.facturaForm.value.nombre;  
            objPersona.razonSocial=this.facturaForm.value.razonSocial;
            objPersona.rfc=this.facturaForm.value.rfc;
            objPersona.cp=this.facturaForm.value.cp;
            objPersona.correoElectronico=this.facturaForm.value.correoElectronico;
            objPersona.idRegimenFiscal=this.facturaForm.value.selectedRegimenFiscal;
            facturacionData.receptor = objPersona;


      let resultado:any= await  this.datosCfdiFacturasService.add(facturacionData).toPromise();
        if(resultado.resultado!="OK")
        {
          this.showErrorTimbre();
          this.flagReintento=true;
          this.progressBar=false;
          return;
        }
        
      this.muestraFactura(resultado.idFactura,resultado.tipoRecibo,this.facturaForm.value.correoElectronico);    
      this.progressBar=false;
      this._flagDatosFactura=false;
  }
  async getIdCobroByCuentaAgua(referencia:string){
    let  objCobro= new BuscaCobros();
         objCobro.cuentaAgua=referencia; 

         objCobro= await  this.buscaCobrosService.getIdCobroByCuentaAgua(objCobro).toPromise();
       return objCobro.id;

  }
 async requiereGenerico(){
    // facturación generica
    try {
   
        this.flagFacturaGenerica=true;
        this.displayFacturaOgenerico=false;

        this.msjProgresBar= 'Realizando Factura, por favor espere...' 

         this.showBar();  
       let  facturacionData = new FacturacionData();
            facturacionData.id= this._id_factura;
       let objPersona = new PersonaClientes();
        objPersona.nombre=this.facturaForm.value.nombre;  
        objPersona.razonSocial=this.facturaForm.value.razonSocial;
        objPersona.rfc=null;// se asignara el rfc de publico en general.
        objPersona.cp= (this.facturaForm.value.cp==null || this.facturaForm.value.cp==undefined || this.facturaForm.value.cp=="" )?"00000":this.facturaForm.value.cp;
        objPersona.correoElectronico=this.facturaForm.value.correoElectronico;
        facturacionData.receptor = objPersona;
        
      let resultado:any= await  this.datosCfdiFacturasService.add(facturacionData).toPromise();
      if(resultado.resultado!="OK")
      {
        this.showErrorTimbre();
        this.flagReintento=true;
        this.progressBar=false;
        return; 
      }

       this.muestraFactura(resultado.idFactura,resultado.tipoRecibo,this.facturaForm.value.correoElectronico);    
    } catch (error) {
      this.muestraMensaje.error("No, se pudo facturar existe un error. ", "top", "center");
    }finally{
      this.progressBar=false;
    }
    }
   async muestraFactura(idFactura,tipoRec,correo){
           await this.imprimeComprobante(idFactura, tipoRec);
           this.enviaCorreo.idFactura = idFactura;
           this.enviaCorreo.correo=correo;
          //  this._id_factura=idFactura;
           await this.enviarCorreo();
           this.bandera=false;
           this._totalAdeudo=0;
           let objCargoDetalleTableLimpio:CargosDetalles[]=[];
           this.childCargosDetalles.cargosDetallesTable=  objCargoDetalleTableLimpio;
           this.childCargosDetalles._totalAdeudo=0;
    }
  async aceptoLosTerminos(){
    this.displayMaximizable=false;
    let info: string;
    info = await this.privilegiosService.GetInfoBrowser().toPromise();

    this.authenticationService
      .login("USER_P_ONLINE", "USER_P_PASSWORD",info)
      .pipe(first())
      .subscribe(
        async (data) => {

          this.flagAceptoLosTerminos = true;
          if(this.cuentaAguaParam){
            this.ngAfterGetToken();
          }

        },
        (error) => {
          this.flagAceptoLosTerminos = false;
        }
      );
  }

  rechazoTerminos(){
    this.displayMaximizable =false;
    this.flagAceptoLosTerminos = false ;
  }

asignaTolstCfdi(x){
 this.lstCfdi.push({ label: x.descripcion, value: x.id });
}
asignaTolstRegimen(x){
  this.lstRegimenFiscal.push({ label: x.descripcion, value: x.id });
}

  async realizaPago() {
 
try {


    if (this._totalAdeudo > 0 && this.childCargosDetalles && this.childEstadoCuentaInformacion) {
       
      //armar cadena, para hacer la petición al banco.

        this.mensajeForm.patchValue({
          mensaje_: 'Realizando pago, por favor espere...'
        });
        this.showBar();
        this._muestraBtnPago = false;
        this.bandera = false;
        let objLimpia:Message[]=[]
        this.msgs =objLimpia;
        let idsCargos = this.childCargosDetalles.cargosDetallesTable.map(({ idCargo }) => idCargo).toString();
        let objwizpokIntentoPagoRequest: WizpokIntentoPagoRequest = new WizpokIntentoPagoRequest();
        objwizpokIntentoPagoRequest.amount= parseFloat(this._totalAdeudo.toFixed(2).toString());
        objwizpokIntentoPagoRequest.customer=this.childEstadoCuentaInformacion.estadoCuentaTable[0].nombreCompleto;
        objwizpokIntentoPagoRequest.idAgua=this.idAguasProceso.toString();
        objwizpokIntentoPagoRequest.arrCargos=idsCargos;
        objwizpokIntentoPagoRequest.cuentaAgua=this.childEstadoCuentaInformacion.estadoCuentaTable[0].cuentaAgua.toString();
        // objwizpokIntentoPagoRequest.subtotal =objwizpokIntentoPagoRequest.amount;
        // objwizpokIntentoPagoRequest.concept=this.idAguasProceso+"X"+ this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.anio ? acc : shot.anio, 0)+
        // "||"+this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.periodoParcialidad ? acc : shot.periodoParcialidad, 0)+
        // "||"+this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.idTipoPeriodo ? acc : shot.idTipoPeriodo, 0)+
        // "||"+ (!this.childCargosDetalles.con_Convenio?0:1)+
        // "||"+(this.childCargosDetalles.estimadoAnual?0:1)+
        // "||"+idsCargos;
        debugger;
        let resultado:any = await this.payCardService.WizpokIntentoPago(objwizpokIntentoPagoRequest).toPromise();
       /* BBVA
       let objPayWorks: PayCard = new PayCard();
         objPayWorks.estimado=this.childCargosDetalles.estimadoAnual;
         objPayWorks.anio = this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.anio ? acc : shot.anio, 0);
         objPayWorks.bimestre = this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.periodoParcialidad ? acc : shot.periodoParcialidad, 0);
         objPayWorks.tipoPeriodo = this.childCargosDetalles.cargosDetallesTable.reduce((acc, shot) => acc = acc > shot.idTipoPeriodo ? acc : shot.idTipoPeriodo, 0);
         objPayWorks.esconsumo = !this.childCargosDetalles.con_Convenio;
         objPayWorks.cuentaAgua = this.idAguasProceso;
         objPayWorks.idAgua=this.childCargosDetalles.cargosDetallesInput.idAgua;    
         objPayWorks.fechaDeposito = new Date();
         objPayWorks.idsCargo = idsCargos.toString();
         objPayWorks.monto = parseFloat(this._totalAdeudo.toString()).toFixed(2);
         objPayWorks.montoSinRedondeo=parseFloat(this._adeudoSinRedondeo.toString());

               let resultado:any = await this.payCardService.PayWorks(objPayWorks).toPromise();
        */

      if (resultado) 
       {
        this.progressBar = false; 
        // const responseObject = JSON.parse(resultado);
        window.open(resultado, '_blank');

       }
       else 
         throw new Error('No se pudo procesar el pago, vuelva a intentar lo, mas tarde');
      

    }
  } catch (e) {
    this.progressBar = false; 
    this.muestraMensaje.error(e.message, "top", "center");
  } finally {

  }
  }
   showBar() {
    this.progressBar = true;
  }
  async enviarCorreo() {
    // console.log('14---------------------------------------');
    try {

      const datosenviarCorreo = new EnviarCorreo();
      datosenviarCorreo.idFactura =  this.enviaCorreo.idFactura ;
      datosenviarCorreo.correo = this.enviaCorreo.correo;
      datosenviarCorreo.correocopia = "";
      await this.datosenviarCorreo$.emit(datosenviarCorreo);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      // console.log("Paso por enviarCorreo");
    }
  }


  async imprimeComprobante(idFactura, reporte) {
    try {
      this._esfactura = true;
 
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.tipo = "pdf";
      this.auxJasper.JasperReport.nombreReporte = "001_Factura";
      
      const id_factura = new ParametroJasper();
      id_factura.nombre = "_id_factura";
      id_factura.valor = idFactura + "";
      let reimpresion = new ParametroJasper();
      reimpresion.nombre = 'reimpresion';
      reimpresion.valor = false + "";
      let timbre = new ParametroJasper();
      timbre.nombre = 'timbre';

      debugger;
      if (reporte === 1) 
          timbre.valor = true + "";
      else
          timbre.valor = false + "";
      
      await this.auxJasper.ParametroJasper.push(reimpresion);
      await this.auxJasper.ParametroJasper.push(timbre);
     
      await this.auxJasper.ParametroJasper.push(id_factura);

   
      await this.showDialog();

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      // console.log("Paso por imprimeComprobante");
    }
  }
  showDialog() {
    this.display = true;
  }
    showErrorTimbre(){
      this.mensajeForm.patchValue({
        mensaje_: 'No se pudo timbrar la factura hubo un error , ¿desea reintentar? .'
      }); 

    this.errorTimbre = true;
  }
  async realizaReintentoFactura() { 
    this.errorTimbre  = false;
    if(!this.flagFacturaGenerica)
        this.realizaFactura();
    
    this.requiereGenerico();

  }

  async impresionComprobante() {
    this.errorTimbre  = false;
    this.imprimeComprobante(this._id_factura, 2);
  }


  async imprimirLiquidacion(){
    
    try {
      this._esfactura = false;
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "liquidacion";
      this.auxJasper.JasperReport.tipo = "pdf";
      this.auxJasper.JasperReport.imprimir = false;
      
      

      let _id_usuario = new ParametroJasper();
      _id_usuario.nombre = "usuario_liquidacion";
      _id_usuario.valor =  "189";
      console.log("parametro", _id_usuario.valor);
      await this.auxJasper.ParametroJasper.push(_id_usuario);

      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "id_agua";
      _id_agua.valor = this.childCargosDetalles.cargosDetallesInput.idAgua + "";
      console.log("parametro", _id_agua.valor);
      await this.auxJasper.ParametroJasper.push(_id_agua);

      //await $(".solicitud").modal("show"); //Para mostrar en forma de Poppup
      //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper.JasperReport }); //Para mostrarlo con pagina independiente
      this.showDialog();


    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }

  }
  mostrarMensaje(mensaje: string) {
    this.msjProgresBar = mensaje;
    this.showBar();

  }

  ocultarMensaje() {
   this.progressBar = false; 
  }

}
